import React from 'react';
import type { HTMLAttributes } from 'react';
import type { ProgressConsistencyProps } from '../types';
import type { ThemeProps } from 'styled-components';
import type { StudentStatusColorType, ThemeType } from '../../../../util/types';
import styled, { css } from 'styled-components';
import { EMPTY_VALUE } from '../../../../util/vars';
import { getPolishedColors } from '../../../../util/styled';

type Ref = HTMLDivElement;
type HTMLProps = HTMLAttributes<Ref>;
interface Props extends ProgressConsistencyProps, HTMLProps {
  /**
   * Elements' length.
   */
  length: number;
  /**
   * Print elements.
   */
  children: React.ReactNode | null;
}

const ProgressConsistencyWrapper = React.forwardRef<Ref, Props>(({
  headline,
  background,
  length,
  children,
  ...other
}: Props, ref): JSX.Element => {
  return (
    <div ref={ref} className={'flex flex-wrap flex-1 h-full'} {...other as HTMLProps}>
      <div className={'flex flex-col w-full h-full text-center p-sm'}>
        <StatusWrapper
          className={'uppercase text-sm font-bold rounded-default py-1 px-2 mb-sm'}
          $color={background as StudentStatusColorType}
        >
          {headline}
        </StatusWrapper>
        <div className={'bg-white flex-1 rounded-default py-1 px-2'}>
          <div className={'font-bold mb-sm'}>{length}</div>
          <div>
            {length === 0 ? (
              <span className={'text-muted'}>
                {EMPTY_VALUE}
              </span>
            ) : (
              <div className={'flex flex-wrap items-center justify-center'}>
                {children}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

const getStatusColor = (props: ThemeProps<ThemeType> & { $color: StudentStatusColorType }) => {

  const colors = getPolishedColors({ theme: props.theme, $color: props.$color });

  return css`
    background: ${colors.main.color};
    color: ${colors.main.readable};
  `;
};

const StatusWrapper = styled('div')<{ $color: StudentStatusColorType }>`
  ${(props) => getStatusColor(props)}
`;

ProgressConsistencyWrapper.displayName = 'ProgressConsistencyWrapper';

export default ProgressConsistencyWrapper;
